export default __webpack_public_path__ + "static/media/vc_connect.16557eef.svg";